<template>
  <div class="questionnaire-question-progress" aria-live="polite">
    <div class="questionnaire-question-progress__bar" aria-hidden="true">
      <div
        class="questionnaire-question-progress__progress"
        :style="{ width: progressWidth }"
      ></div>
    </div>
    <div class="questionnaire-question-progress__counter">
      <a-label path="questionnaire.question" :is-visible="true"></a-label>
      {{ questionnaireContext.questionIndex + 1 }}
      <span aria-hidden="true">/</span
      ><span class="a-visually-hidden"
        ><a-label path="counter.of"></a-label
      ></span>
      {{ questionnaireContext.questionAmount }}
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    questionnaireContext: {
      default() {
        return () => {};
      },
    },
  },
  computed: {
    progressWidth() {
      return `${
        (100 / this.questionnaireContext.questionAmount) *
        (this.questionnaireContext.questionIndex + 1)
      }%`;
    },
  },
};
</script>
